<template>
	<v-container class="pa-1">
		<v-row>
			<v-col v-for="(image, index) in images" :key="image" cols="6" sm="4" md="3" lg="2">
				<v-card flat tile>
					<v-img contain :src="image" class="grey lighten-2" @click="showImage(index)">
						<template #placeholder>
							<v-row class="fill-height ma-0" align="center" justify="center">
								<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
							</v-row>
						</template>
					</v-img>
				</v-card>
			</v-col>
		</v-row>

		<v-dialog v-model="dialogImage">
			<v-container class="pa-0 fill-height">
				<v-img contain :src="currentImage" class="grey lighten-2" :style="getHeight">
					<v-row class="pa-0 white--text fill-height">
						<v-col class="text-left pa-0 pt-1 pl-4" cols="12">
							<v-btn
								:small="$vuetify.breakpoint.xsOnly"
								class="primary"
								rounded
								icon
								@click="dialogImage = false"
							>
								<v-icon color="white">mdi-close</v-icon>
							</v-btn>
						</v-col>
						<v-col class="px-4" cols="6" align-self="center">
							<v-btn
								:small="$vuetify.breakpoint.xsOnly"
								class="text-h6 font-weight-light primary"
								icon
								@click="changeIndex(-1)"
							>
								<v-icon color="white">mdi-chevron-right</v-icon>
							</v-btn>
						</v-col>
						<v-col class="text-left px-4" cols="6" align-self="center">
							<v-btn
								:small="$vuetify.breakpoint.xsOnly"
								class="text-h6 font-weight-light primary"
								icon
								@click="changeIndex(1)"
							>
								<v-icon color="white">mdi-chevron-left</v-icon>
							</v-btn>
						</v-col>
						<v-col class="text-center" cols="12" align-self="end">
							<a :href="currentImage" download target="_blank">
								<v-btn :small="$vuetify.breakpoint.xsOnly" class="primary" rounded>تحميل</v-btn>
							</a>
						</v-col>
					</v-row>
				</v-img>
			</v-container>
		</v-dialog>
	</v-container>
</template>

<script>
export default {
	props: {
		images: {
			type: Array,
			default: function() {
				return [];
			}
		}
	},
	data() {
		return {
			currentImage: "",
			currentIndex: -1,
			dialogImage: false
		};
	},
	computed: {
		getHeight() {
			var height = window.innerHeight - 100;
			return "height: " + height + "px;";
		}
	},
	watch: {
		currentIndex(newVal) {
			if (newVal < 0) {
				this.currentIndex = this.images.length - 1;
				return;
			}

			if (newVal >= this.images.length) {
				this.currentIndex = 0;
				return;
			}

			this.currentImage = this.images[newVal];
		}
	},
	methods: {
		showImage(index) {
			this.dialogImage = true;
			this.currentIndex = index;
		},
		changeIndex(amount) {
			this.currentIndex += amount;
		}
	}
};
</script>

<style scoped>
.v-dialog__content ::v-deep .v-dialog {
	width: auto;
}
</style>